import { render } from "./UQAddUnit.vue?vue&type=template&id=8c302c5e&scoped=true"
import script from "./UQAddUnit.vue?vue&type=script&lang=js"
export * from "./UQAddUnit.vue?vue&type=script&lang=js"

import "./UQAddUnit.vue?vue&type=style&index=0&id=8c302c5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c302c5e"]])

export default __exports__